import { Client } from "@/Common/Api/Client";
import { SharedItemPatientSendingSettings } from "@/Common/Models/Patient/SharedItemPatientSendingSettings";
import { GetPatientOverviewResponse } from "@/Common/Models/Portal/MedfarPortal";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { IncreasePatientMessagesLimitResponse } from "./Dto/IncreasePatientMessagesLimitResponse";
import { SharedItemPatientSendingSettingsResponse } from "./Dto/SharedItemPatientSendingSettings";

class PatientPortalClient {
    public static async increasePatientMessagesLimit(patientContactFacetId: string, currentPatientMessagesLimit: number, messagesLimitIncrement: number): Promise<IncreasePatientMessagesLimitResponse> {
        if (patientContactFacetId == null || currentPatientMessagesLimit == null) {
            return null;
        }

        const response = await Client.postAsync<IncreasePatientMessagesLimitResponse>(
            ServerOperations.Server.Myle_PortalCommunication_IncreasePatientSendingSettingsMessagesLimit,
            {
                PatientContactFacetId: patientContactFacetId,
                NewMessagesLimit: currentPatientMessagesLimit + messagesLimitIncrement
            }
        );

        if (response?.errors?.any()) {
            return null;
        }

        return response.data;
    }

    public static async getPatientSendingSettings(patientContactId: string): Promise<SharedItemPatientSendingSettings> {
        if (!patientContactId) {
            return null;
        }

        const response = await Client.postAsync<{ SharedItemPatientSendingSettings: SharedItemPatientSendingSettingsResponse }>(
            ServerOperations.Server.Myle_PortalCommunication_GetPatientSendingSettings,
            {
                PatientContactId: patientContactId
            }
        );

        if (response?.errors?.any()) {
            return null;
        }

        return SharedItemPatientSendingSettings.fromResponse(response.data.SharedItemPatientSendingSettings);
    }

    public static async toggleBlockedStatus(patientContactFacetId: string, isBlocked: boolean, reason: string): Promise<SharedItemPatientSendingSettings> {
        if (!patientContactFacetId) {
            return null;
        }

        const response = await Client.postAsync<{ SharedItemPatientSendingSettings: SharedItemPatientSendingSettingsResponse }>(
            ServerOperations.Server.Myle_PortalCommunication_SetPatientSendingSettingsBlockedStatus,
            {
                PatientContactFacetId: patientContactFacetId,
                IsBlocked: isBlocked,
                Reason: reason
            }
        );

        if (response?.errors?.any()) {
            return null;
        }

        return SharedItemPatientSendingSettings.fromResponse(response.data.SharedItemPatientSendingSettings);
    }

    /**
     * Loads the portal account overview for a patient.
     * @param patientContactId The ID of the patient for whom the portal account overview is to be loaded.
     */
    public static async loadPortalAccountOverviewAsync(patientContactId: string): Promise<GetPatientOverviewResponse> {
        const response = await Client.postAsync<GetPatientOverviewResponse>(ServerOperations.Server.Portal_Proxy_GetPatientPortalProfileOverview, { PatientContactId: patientContactId });

        if (response.errors?.any()) {
            sessionStore.showPopup(response.errors);
            return null;
        }

        return response.data;
    }
}

export { PatientPortalClient };
